import React, { Component } from 'react';
export default class Welcome extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <section class='bg-white pt-[90px] pb-5 md:pt-[120px] md:pb-20'>
        <div class='container'>
          <div class='grid grid-cols-1'>
            <div class='bg-light text-center py-10 md:py-[60px] px-[30px]'>
              <div class='max-w-[430px] mx-auto'>
                <form class='relative'>
                  {/* <input
                    type='text'
                    class='form-input h-[52px] py-3.5 px-4 text-sm !pr-[160px] text-dark rounded-full bg-white border border-solid !border-[#ededed]'
                    placeholder='Email Address'
                  />
                  <button class='absolute tracking-[1px] font-normal text-sm rounded-full capitalize top-1 right-1 outline-none py-[11px] px-[30px] hover:bg-[#07897e] hover:border-[#07897e] duration-500 bg-custom text-white border border-custom'>
                    Liên hệ
                  </button> */}
                </form>
              </div>
              <div class='h-[3px] bg-custom w-14 inline-block mt-10 mb-5 mx-0'></div>
              <div class='max-w-[650px] mx-auto'>
                {/* <h1 class='font-semibold leading-[1.4] text-[32px] md:text-[46px]'>
                  Chúng tôi tư vấn thi công và cung cấp các loại quạt công
                  nghiệp.
                </h1>
                <p class='text-muted mx-auto md:text-lg mt-4 max-w-[500px]'>
                  We created a simple, safe, and easy-to-use platform for
                  managing the complex banking of startups.
                </p> */}
                <div class='mt-6'>
                  {/* <a
                    href='#'
                    data-type='youtube'
                    data-id='YjhrligRTbE'
                    class='lightbox text-white'
                  >
                    <i class='mdi mdi-play bg-custom h-[66px] w-[66px] leading-[66px] text-[34px] shadow-[0px_0px_0px_6px_rgb(10,161,149,0.15)] rounded-full inline-block text-center'></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
